import { InventoryData, InventoryLocationQuantities } from "../inventory/data/model/inventoryData"
import { LabelDto } from "../label/Label"
import { TYPE_PRODUCTS } from "./Constants"
import { BILLING_METHOD, PRICING_STRATEGY, PRODUCT_TYPE } from "./Types"
import Bundle, { BundleDto, initialBundleState } from "./bundle/models/Bundle"
import { CurrencyPricingDto, CurrencyPricingDtoAttributes } from "./currencypricing/CurrencyPricing"
import Matrix, { MatrixDto, initialMatrixState } from "./matrix/Matrix"
import { PricingBracketRequestDto } from "./matrix/MatrixDto"
import { SupplierCost, SupplierCostElastic } from "./models"
import { PricingBracketsDto } from "./pricingbrackets/PricingBrackets"
import { ProductInitialState } from "./reducer"

export type ProductDtoAttributes = {
    title: string
    sku: string
    barcode:string
    billingMethods: BILLING_METHOD[]
    pricingStrategy: PRICING_STRATEGY
    pricingBrackets: (PricingBracketsDto | PricingBracketRequestDto)[]
    multiCurrencyPricing: (CurrencyPricingDto | CurrencyPricingDtoAttributes)[]
    manufacturerSku: string
    shortDescription: string
    longDescription: string
    type: PRODUCT_TYPE
    matrix: MatrixDto
    defaultUnitCost: string
    defaultUnitPrice: string
    currency: string
    monthlyUnitCost: string
    monthlyUnitPrice: string
    yearlyUnitCost: string
    yearlyUnitPrice: string
    updatedAt: string
    bundle: BundleDto
    trackSerialNumber: boolean
    imageIds: Array<string>
    images: Array<string>
	labels: LabelDto[]
    labelIds: string[]
    unitOfMeasure: string
    quantityOnHand: string
    inventoryTracking: boolean
    isNonInventory: boolean
    id?:string
    inventoryLocationEstimatedCosts: inventoryLocationEstimatedCosts[]
    inventoryLocationQuantities:InventoryLocationQuantities[]
    inventoryData: InventoryData[]
    supplierCosts: Array<SupplierCost> | Array<SupplierCostElastic>
    oneTimeMinimumPrice: string
    oneTimeMinimumCost: string
    monthlyMinimumPrice: string
    yearlyMinimumPrice: string
}

export type inventoryLocationEstimatedCosts = {
    estimatedCost: string
    inventoryLocationId: string
    id: string
    currency: string
    
}

export type ProductDto = {
    id: string
    type: string
    attributes: ProductDtoAttributes
}

export const initialProductState: ProductInitialState = {
    id: "",
    title: "",
    sku: "",
    barcode:"",
    billingMethods: [BILLING_METHOD.ONE_TIME],
    pricingStrategy: PRICING_STRATEGY.MULTIPLIER,
    pricingBrackets: [],
    multiCurrencyPricing: [],
    manufacturerSku: "",
    shortDescription: "",
    longDescription: "",
    type: PRODUCT_TYPE.SINGLE,
    matrix: initialMatrixState,
    defaultUnitCost: "0.00",
    defaultUnitPrice: "0.00",
    currency: "",
    monthlyUnitCost: "0.00",
    monthlyUnitPrice: "0.00",
    yearlyUnitCost: "0.00",
    yearlyUnitPrice: "0.00",
    updatedAt: "",
    bundle: initialBundleState,
    trackSerialNumber: false,
    imageIds: [],
    images: [],
    labels: [],
    labelIds: [],
    unitOfMeasure: "",
    quantityOnHand: "0",
    inventoryTracking: false,
    isNonInventory: false,
    inventoryLocationEstimatedCosts: [],
    inventoryLocationQuantities:[],
    inventoryData: [],
    supplierCosts: [],
    oneTimeMinimumPrice: "",
    oneTimeMinimumCost: "",
    monthlyMinimumPrice: "",
    yearlyMinimumPrice: "",
}

export default class Product {
    private dto: ProductDto

    constructor(dto: ProductDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.type === TYPE_PRODUCTS
            && this.getId() != ""
    }

    getId(): string {
        return this.dto.id
    }

    getDto(): ProductDto {
        return this.dto
    }

    getAttributes(): ProductDtoAttributes {
        return this.dto.attributes
    }

    trackSerialNumber(): boolean {
        return this.dto.attributes.trackSerialNumber
    }

    title(): string {
        return this.dto.attributes.title
    }

    getMatrix(): Matrix {
        return new Matrix(this.dto.attributes.matrix)
    }

    getBundle(): Bundle {
        return new Bundle(this.dto.attributes.bundle)
    }

    setId() {
        this.dto.attributes.id=this.getId()
    }
}


// WEBPACK FOOTER //
// ./src/state/product/Product.ts